export enum IQueryName {
  QUERY_CONTACT_LIST = "query contact list",
  MUTATION_EDIT_CONTACT_LIST = "edit contact list",
  QUERY_GROUPS = "query groups",
  QUERY_GROUPS_BY_SEARCH = "query groups by search",
  MUTATION_CREATE_GROUP = "create group",
  MUTATION_EDIT_GROUP = "edit group",
  MUTATION_DELETE_GROUP = "delete group",
  QUERY_PARTICIPANTS = "query participants",
  QUERY_PARTICIPANTS_FOR_GROUPS_BY_SEARCH = "query participants for groups by search",
  QUERY_CONTACTS = "query contacts",
  QUERY_ALL_CONTACTS = "query all contacts",
  MUTATION_CREATE_CONTACT = "create contact",
  MUTATION_EDIT_CONTACT = "edit contact",
  MUTATION_DELETE_CONTACT = "delete contact",
  MUTATION_IMPORT_CONTACTS = "import contacts",
  SAVE_APP_CONFIG = "save app config",
}
